import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'shared/button/button.module';
import { DropdownModule } from 'shared/dropdown/dropdown.module';
import { RadialProgressModule } from 'shared/radial-progress/radial-progress.module';

import { AccountDropdownComponent } from './account-dropdown/account-dropdown.component';
import { CurrentTasksComponent } from './current-tasks/current-tasks.component';
import { AccountService } from './account.service';


@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    DropdownModule,
    RadialProgressModule,
  ],
  declarations: [
    AccountDropdownComponent,
    CurrentTasksComponent,
  ],
  exports: [
    AccountDropdownComponent,
    CurrentTasksComponent,
   ],
  providers: [AccountService]
})
export class AccountModule {}
